import React from 'react'
import { withIcon } from '../../withIcon'

function PreviewIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.625 7V17H20.375V7H3.625ZM2.375 6.72392C2.375 6.14418 2.86471 5.75 3.37473 5.75H20.6253C21.1353 5.75 21.625 6.14418 21.625 6.72392V17.2761C21.625 17.8543 21.1361 18.25 20.6253 18.25H3.37473C2.86387 18.25 2.375 17.8543 2.375 17.2761V6.72392Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M14.7368 12.0858L10 14.5019V9.66974L14.7368 12.0858Z" fill={color}/>
    </svg>
  )
}

export default withIcon(PreviewIcon)
